/**
 * AWS RUM configuration for the MediaShare.link web client.
 *
 * Values come from the infra RumStack CfnOutputs (one app monitor per
 * stage). After the infra pipeline deploys the RUM stacks, read the outputs
 * and replace the REPLACED_AFTER_DEPLOY placeholders below:
 *
 *   aws cloudformation describe-stacks --region us-west-2 \
 *     --query 'Stacks[?contains(StackName, `RumStack`)].Outputs' \
 *     --output table
 *
 * While a placeholder is present, RUM stays disabled (see rumAllowed) — so
 * this file is safe to ship ahead of the infra deploy. The guest role ARNs
 * are predictable (explicit roleName in RumStack) and already correct.
 */
const PROD_APP_MONITOR_ID = "d3af513f-ec68-4b65-b4b7-0e1a68cc8684";
const PROD_IDENTITY_POOL_ID = "us-west-2:34407ade-fb2c-4469-8872-3eba9bc7548b";
const PROD_GUEST_ROLE_ARN = "arn:aws:iam::136332742685:role/mediashare-rum-guest-prod";
const BETA_APP_MONITOR_ID = "54cafea8-7652-4b22-946c-191c2425f72f";
const BETA_IDENTITY_POOL_ID = "us-west-2:4bcfa928-8ada-44e2-812f-576aa8c45c3c";
const BETA_GUEST_ROLE_ARN = "arn:aws:iam::136332742685:role/mediashare-rum-guest-beta";
// Mirrors the stage detection in API.tsx getAPIEndpoint: localhost and
// test.mediashare.link are beta-tier; everything else is prod. Local dev
// gets no RUM at all.
export const getRumStage = (href, hostname) => {
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "local";
    }
    if (href.includes("test.mediashare.link")) {
        return "beta";
    }
    return "prod";
};
export const buildRumConfig = (stage) => {
    if (stage === "prod") {
        return {
            appMonitorId: PROD_APP_MONITOR_ID,
            identityPoolId: PROD_IDENTITY_POOL_ID,
            guestRoleArn: PROD_GUEST_ROLE_ARN,
            region: "us-west-2",
        };
    }
    if (stage === "beta") {
        return {
            appMonitorId: BETA_APP_MONITOR_ID,
            identityPoolId: BETA_IDENTITY_POOL_ID,
            guestRoleArn: BETA_GUEST_ROLE_ARN,
            region: "us-west-2",
        };
    }
    return {
        appMonitorId: "",
        identityPoolId: "",
        guestRoleArn: "",
        region: "us-west-2",
    };
};
